/**
 * 通用后端代理的请求体构建（/generate/image、/generate/video）
 * 直连 Pollo/AllAll 的 body 由 api/ai/adapters 各自 buildBody 负责
 */

export function buildImageParams(params) {
  var baseParams = {
    model: params.modelId,
    prompt: params.prompt,
    negative_prompt: params.negativePrompt || '',
    image: params.referenceImage || null,
    model_version: params.modelVersion || 'Pro',
    output_format: params.outputFormat || 'JPEG',
    prompt_enhance: params.promptEnhance || false,
    size: params.size || '1024x1024',
    count: params.count || 1,
    seed: params.seed || null
  }

  if (params.modelId === 'nano-banana') {
    baseParams.model_version = params.modelVersion || 'standard'
    baseParams.image_size = params.imageSize || 'auto'
    if (params.modelVersion === 'pro') {
      baseParams.resolution = params.resolution || '1K'
    }
  }

  if (params.modelId === 'seedream-4' || params.modelId === 'seedream-5') {
    baseParams.image_size = params.imageSize || '1:1'
    baseParams.resolution = params.resolution || '2K'
    baseParams.web_search = params.webSearch || false
    baseParams.reference_image = params.referenceImage || null
  }

  if (params.modelId === 'midjourney') {
    baseParams.speed = params.speed || 'fast'
    baseParams.image_size = params.imageSize || '1:1'
  }

  if (params.modelId === 'gpt-image-1' || params.modelId === 'gpt-image-1-5') {
    baseParams.image_size = params.imageSize || '1024x1024'
    baseParams.image_count = 1
    baseParams.prompt_enhance = false
  }

  return baseParams
}

export function buildVideoParams(params) {
  var baseParams = {
    model: params.modelId,
    prompt: params.prompt,
    negative_prompt: params.negativePrompt || '',
    mode: params.videoMode || 'text',
    reference_media: params.referenceImage || null,
    reference_audio: params.referenceAudio || null,
    duration: params.videoDuration || 5,
    resolution: params.videoRes || '480p',
    aspect_ratio: params.aspectRatio || '16:9',
    generate_audio: params.generateAudio || false,
    seed: params.seed || null
  }

  if (params.modelId === 'seedance' || params.modelId === 'wan-2-2') {
    baseParams.end_frame = params.endFrameImage || null
  }

  if (params.modelId === 'sora-2') {
    baseParams.remove_watermark = params.removeWatermark || false
    baseParams.duration = params.videoDuration || 10
    baseParams.aspect_ratio = params.aspectRatio || '16:9'
    baseParams.mode = params.videoMode || 'text'
    if (params.videoMode === 'image' && params.referenceImage) {
      baseParams.reference_media = params.referenceImage
    }
  }

  if (params.modelId === 'hailuo-2-3') {
    baseParams.duration = params.videoDuration || 6
    baseParams.prompt_enhance = params.promptEnhance || false
    baseParams.mode = params.videoMode || 'text'
    if (params.videoMode === 'image' && params.referenceImage) {
      baseParams.reference_media = params.referenceImage
    }
  }

  if (params.modelId === 'runway') {
    baseParams.duration = params.videoDuration || 5
    baseParams.aspect_ratio = params.aspectRatio || '16:9'
    baseParams.seed = params.seed || null
    baseParams.mode = params.videoMode || 'text'
    if (params.videoMode === 'image' && params.referenceImage) {
      baseParams.reference_media = params.referenceImage
    }
  }

  if (params.modelId === 'wan-animate') {
    baseParams.animate_mode = params.animateMode || 'animate'
    baseParams.animate_param_mode = params.animateParamMode || 'std'
    baseParams.watermark = params.watermark === true
    baseParams.reference_image = params.referenceImage || null
    baseParams.reference_video = params.referenceVideo || null
    baseParams.prompt = params.prompt || ''
  }

  if (params.modelId === 'veo-3-1') {
    baseParams.generation_type = params.veoGenType || 'fast'
    baseParams.image_mode = params.veoImageMode || 'frames'
    baseParams.start_frame = params.startFrame || null
    baseParams.end_frame = params.endFrame || null
    baseParams.reference_images = params.veoRefImages || null
    baseParams.aspect_ratio = params.aspectRatio || '16:9'
  }

  if (params.modelId === 'kling-2-6' || params.modelId === 'kling-2-5' || params.modelId === 'kling-3') {
    baseParams.mode = params.videoMode || 'text'
    baseParams.duration = params.videoDuration || 5
    baseParams.aspect_ratio = params.aspectRatio || '16:9'
    baseParams.generate_audio = params.generateAudio || false
    if (params.videoMode === 'image' && params.referenceImage) {
      baseParams.reference_media = params.referenceImage
    }
  }

  return baseParams
}
